import React from "react";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {MultiSelect} from "primereact/multiselect";

const StoreSubmitSection = ({
	availableMagazins,
	selectedMagazin,
	setSelectedMagazin,
	availableDrivers,
	selectedDrivers,
	setSelectedDrivers,
	availableCollectors,
	selectedCollectors,
	setSelectedCollectors,
	shipmentComment,
	setShipmentComment,
	isEditMode,
	isCreatingShipment,
	isLoading,
	handleCreateShipment,
}) => {
	const magazinOptions = availableMagazins.map((magazin) => ({
		label: magazin.name,
		value: magazin.name,
	}));

	const driverOptions = availableDrivers.map((driver) => ({
		value: driver.id,
		label: driver.name,
	}));

	const collectorOptions = availableCollectors.map((collector) => ({
		value: collector.id,
		label: collector.name,
	}));

	const handleMagazinChange = (e) => {
		if (isEditMode) return;
		setSelectedMagazin(e.value);
	};

	return (
		<div className="flex items-center gap-4 py-4">
			<Dropdown
				options={magazinOptions}
				onChange={handleMagazinChange}
				value={selectedMagazin}
				placeholder="Magazin танлаш"
				className="w-[12em] border h-[46px] pt-[2px]"
				loading={isLoading}
				filter
				disabled={isEditMode}
			/>

			<Dropdown
				options={driverOptions}
				onChange={(e) => setSelectedDrivers(e.value)}
				value={selectedDrivers}
				placeholder="Шафёрни танлаш"
				className="w-[20em] border h-[46px] pt-[2px]"
			/>

			<MultiSelect
				options={collectorOptions}
				onChange={(e) => setSelectedCollectors(e.value)}
				value={selectedCollectors}
				placeholder="Йиғувчиларни танлаш"
				className={`border h-[46px] pt-[2px] w-[20em] max-w-[40em] ${
					selectedCollectors.length ? `w-full` : ""
				}`}
				display="chip"
			/>

			<InputText
				value={shipmentComment}
				onChange={(e) => setShipmentComment(e.target.value)}
				placeholder="Izoh"
				className="min-w-[18em] py-2 pt-3 pl-2 border"
			/>

			<div className="flex items-center justify-end w-full">
				<Button
					label={isEditMode ? "Ўзгартириш" : "Жўнатиш"}
					className="px-5 min-w-[100px] text-white bg-blue rounded-md hover:bg-opacity-90 py-3 mr-6"
					onClick={handleCreateShipment}
					loading={isCreatingShipment}
					disabled={isCreatingShipment}
				/>
			</div>
		</div>
	);
};

export default StoreSubmitSection;
